const STORAGE_KEY = 'mgc_pending_deep_link'

/**
 * Lee ?abrir=/ruta&codigo=XXX (o path+search actuales) y arma destino interno.
 * Usado para deep links desde correo: S3 solo sirve "/" / index.html.
 */
export function parseDeepLinkFromSearch(search) {
  const params = new URLSearchParams(search || '')
  const abrir = (params.get('abrir') || params.get('next') || '').trim()
  const codigo = (params.get('codigo') || '').trim()
  if (!abrir) return null

  // Solo rutas internas relativas tipadas
  let path = abrir.startsWith('/') ? abrir : `/${abrir}`
  path = path.split('?')[0]

  const allowed = ['/solicitudes-excepcion-mora', '/simulador-mora-excepcion']
  if (!allowed.includes(path)) return null

  if (codigo) {
    return `${path}?codigo=${encodeURIComponent(codigo)}`
  }
  return path
}

export function savePendingDeepLink(target) {
  if (!target) return
  try {
    sessionStorage.setItem(STORAGE_KEY, target)
  } catch {
    /* ignore */
  }
}

export function consumePendingDeepLink() {
  try {
    const v = sessionStorage.getItem(STORAGE_KEY)
    if (v) sessionStorage.removeItem(STORAGE_KEY)
    return v || null
  } catch {
    return null
  }
}

export function peekPendingDeepLink() {
  try {
    return sessionStorage.getItem(STORAGE_KEY)
  } catch {
    return null
  }
}

/** Si la URL actual trae abrir/codigo, lo persiste. */
export function captureDeepLinkFromLocation(search = window.location.search) {
  const target = parseDeepLinkFromSearch(search)
  if (target) savePendingDeepLink(target)
  return target
}
